import { useState, useEffect, useRef } from 'react';

const useTimer = (timerTime=119) => {
  const [time, setTime] = useState(timerTime);
  const [isRunning, setIsRunning] = useState(false);
  const timerRef = useRef(null);

  const startTimer = () => {
    setIsRunning(true);
  };

  const resetTimer = (seconds) => {
    if (seconds) {
      setTime(seconds);
    } else {
      resetTimer(timerTime);
    }
    setIsRunning(false);
  };

  useEffect(() => {
    if (isRunning && time > 0) {
      timerRef.current = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (time === 0) {
      resetTimer();
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [isRunning, time]);

  const hour = Math.floor(time / 60);
  const formattedTime = `${hour < 10 ? `0${Math.floor(time / 60)}` : hour}:${(
    time % 60
  )
    .toString()
    .padStart(2, '0')}`;

  return {
    remainingSeconds: time,
    time: formattedTime,
    startTimer,
    resetTimer,
    isRunning
  };
};

export default useTimer;
